<template>
  <bm-unit-base
    v-bind="$attrs"
    :value="value"
    :unit-preference="unitPreference"
    @input="$emit('input', $event)"
  />
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import BmUnitBase from "@/components/controls/input/specialised/BmUnitBase.vue";

export default defineComponent({
  components: {
    BmUnitBase,
  },
  name: "BmWeight",
  props: {
    value: {
      type: Number as PropType<number | null>,
      default: null,
      required: false,
    },
  },
  setup() {
    return {
      unitPreference:
        tenantService.settings.displayUnitPreferences.generalWeights,
    };
  },
});
</script>
